import styled from 'styled-components';

/* ----------------------------------
   What We Review
----------------------------------- */

export const AuditReviewSection = styled.section`
  width: 100%;

  display: grid;
  grid-template-columns: minmax(280px, 0.85fr) minmax(0, 1.15fr);
  gap: var(--space-xxxl);

  align-items: flex-start;

  @media screen and (max-width: 950px) {
    grid-template-columns: 1fr;
    gap: var(--space-xl);
  }
`;

export const SectionHeading = styled.div`
  max-width: 650px;

  ${({ $center }) =>
    $center &&
    `
      margin-left: auto;
      margin-right: auto;
      text-align: center;
    `}

  h2 {
    margin: var(--space-xs) 0 var(--space-m);

    color: var(--grey7);

    font-size: clamp(2rem, 3.6vw, 3rem);
    line-height: 1.05;
    font-weight: 900;
    letter-spacing: -0.035em;
  }

  > p:not(.eyebrowHeader) {
    margin: 0;

    color: var(--grey4);

    font-size: 1rem;
    line-height: 1.75;
    font-weight: 500;
  }
`;

export const AuditReviewRows = styled.div`
  border-top: 1px solid var(--grey);
`;

export const AuditReviewRow = styled.div`
  padding: var(--space-xl) 0;

  display: grid;
  grid-template-columns: 50px minmax(0, 1fr);
  gap: var(--space-l);

  border-bottom: 1px solid var(--grey);

  h3 {
    margin: 0 0 var(--space-xs);

    color: var(--grey7);

    font-size: 1.3rem;
    line-height: 1.2;
    font-weight: 900;
  }

  p {
    margin: 0;

    color: var(--grey4);

    font-size: 0.92rem;
    line-height: 1.7;
  }

  @media screen and (max-width: 500px) {
    grid-template-columns: 38px minmax(0, 1fr);
    gap: var(--space-s);
  }
`;

export const AuditNumber = styled.span`
  padding-top: 0.15rem;

  color: var(--orange5);

  font-size: 0.78rem;
  font-weight: 900;
  letter-spacing: 0.08em;
`;
